/**
 * BT-049 / BT-050 — Messages backend staging (source : karateUiI18n).
 */
import { getKarateUi } from "@/i18n/karateUiI18n.js";

/** @param {'fr'|'en'} locale */
export function getBackendStagingMessages(locale = "fr") {
  return getKarateUi(locale).backendStaging;
}

/** @deprecated use getBackendStagingMessages(locale) */
export const BACKEND_ZONE_MESSAGES = {
  demoLocalAwaiting: { fr: getKarateUi("fr").backendStaging.demoLocalAwaiting, en: getKarateUi("en").backendStaging.demoLocalAwaiting },
  managerPrepared: { fr: getKarateUi("fr").backendStaging.managerPrepared, en: getKarateUi("en").backendStaging.managerPrepared },
  userPrepared: { fr: getKarateUi("fr").backendStaging.userPrepared, en: getKarateUi("en").backendStaging.userPrepared },
  backendConnected: { fr: getKarateUi("fr").backendStaging.backendConnected, en: getKarateUi("en").backendStaging.backendConnected },
};

export const STAGING_EMAILS_NOTICE_FR = getKarateUi("fr").backendStaging.stagingAccountsNotice;
export const STAGING_EMAILS_NOTICE_EN = getKarateUi("en").backendStaging.stagingAccountsNotice;

/** Emails staging temporaires — format BT-049 */
export const STAGING_EMAILS = {
  gilles: "gilles.staging@shotokan-aamc.local",
  marcel: "marcel.staging@shotokan-aamc.local",
  natalie: "natalie.staging@shotokan-aamc.local",
  parentDemo: "parent.demo.staging@shotokan-aamc.local",
  responsable1: "responsable1.staging@shotokan-aamc.local",
};
